<div class="saved-search-title helvetica-neue-regular-font">
    <h5 [innerHtml]="referenceDataLabels.SaveSearches|localizeLabel"></h5>
</div>
<div class="saved-searches-container">
    <div *ngFor="let search of savedSearches" class="column">
        <div class="saved-search-name">
            <span class="link" [innerHtml]="search.SearchSaveName" (click)="applySearchEmitter.emit(search)"></span>
            <div class="delete-bin-button"
                (click)="searchForDeletion=search; isDeleteSearchConfirmationDialogOpened=true;">
            </div>
        </div>
        <div class="link-container">
            <a (click)="applySearchEmitter.emit(search)" [innerHtml]="referenceDataLabels.SaveSearchApply|localizeLabel"
                class="search-link"></a>&nbsp;{{ savedSearchesNameSeparator }}&nbsp;
            <a (click)="searchForDeletion=search; isDeleteSearchConfirmationDialogOpened=true;"
                [innerHtml]="referenceDataLabels.SaveSearchDelete|localizeLabel" class="search-link"></a>
        </div>
    </div>
</div>

<ng-container *ngIf="isDeleteSearchConfirmationDialogOpened">
    <boi-confirmation-dialog class="vo-modal vo-modal--standard" [(opened)]="isDeleteSearchConfirmationDialogOpened"
        [titleLabel]="referenceDataLabels.SaveSearchDelete"
        [confirmationLabel]="referenceDataLabels.SaveSearchDeleteConfirmation"
        [confirmationButtonLabel]="referenceDataLabels.OkText"
        (confirmAction)="deleteSearchEmitter.emit(searchForDeletion)">
    </boi-confirmation-dialog>
</ng-container>